// import apiClient from './apiClient';
// import { authService } from '../utilities/auth/authService';

// export const getAnswers = (params) => {
//     let onMessageCallback = null;

//     const promise = new Promise((resolve, reject) => {
//         // Get the token and username using authService - wrapped in an async IIFE
//         (async () => {
//             try {
//                 const token = await authService.getAccessToken();
//                 const username = authService.getUsername();

//                 const url = `${apiClient.defaults.baseURL}combineflow-invoke`;

//                 console.log('getAnswers: Initiating POST request with params:', params);

//                 return fetch(url, { // Return the fetch promise
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'text/event-stream',
//                         // Add authorization header with token
//                         ...(token && { 'Authorization': `Bearer ${token}` }),
//                         // Add username header if available
//                         ...(username && { 'X-Username': username })
//                     },
//                     body: JSON.stringify(params),
//                 }).then(response => {
//                     if (!response.ok) {
//                         console.error('getAnswers: Response not OK:', response.status, response.statusText);
//                         throw new Error(`HTTP error! Status: ${response.status}`);
//                     }

//                     const reader = response.body.getReader();
//                     const decoder = new TextDecoder();
//                     let buffer = '';
//                     let finalMessage = null;

//                     const processStream = async () => {
//                         while (true) {
//                             const { done, value } = await reader.read();
//                             if (done) {
//                                 console.log('getAnswers: Stream complete, resolving with final message:', finalMessage);
//                                 resolve(finalMessage);
//                                 return;
//                             }

//                             buffer += decoder.decode(value, { stream: true });
//                             // Correctly split by double newlines that separate SSE events
//                             const lines = buffer.split('\n\n');
//                             buffer = lines.pop() || ''; // Keep the last potentially incomplete event

//                             for (let i = 0; i < lines.length; i++) {
//                                 const line = lines[i].trim();
//                                 if (line.startsWith('data: ')) {
//                                     try {
//                                         const data = JSON.parse(line.slice(6));
//                                         console.log('getAnswers: Received event:', data);

//                                         if (data.type === 'stream_complete') {
//                                             console.log('getAnswers: Stream complete event received');
//                                             resolve(finalMessage);
//                                             return;
//                                         } else if (data.type === 'error') {
//                                             console.error('getAnswers: Error event received:', data.content);
//                                             reject(new Error(data.content));
//                                             return;
//                                         } else if (data.type === 'ai') {
//                                             finalMessage = data;
//                                             if (onMessageCallback) {
//                                                 console.log('getAnswers: Triggering onMessage callback with AI event:', data);
//                                                 onMessageCallback(data);
//                                             }
//                                         } else if (data.type === 'node_update') {
//                                             if (onMessageCallback) {
//                                                 console.log('getAnswers: Triggering onMessage callback with node_update event:', data);
//                                                 onMessageCallback(data);
//                                             }
//                                         }
//                                     } catch (e) {
//                                         console.error('getAnswers: Error parsing event:', e, 'Line:', line);
//                                     }
//                                 }
//                             }
//                         }
//                     };

//                     processStream().catch(err => {
//                         console.error('getAnswers: Stream processing error:', err);
//                         reject(err);
//                     });
//                 }).catch(err => { // Catch errors from the fetch promise
//                     console.error('getAnswers: Fetch error:', err);
//                     reject(err);
//                 });
//             } catch (error) {
//                 console.error('getAnswers: Error obtaining token:', error);
//                 reject(error);
//             }
//         })(); // Immediately invoked async function expression
//     });

//     console.log('getAnswers: Returning stream object');
//     return {
//         promise,
//         onMessage: (callback) => {
//             console.log('getAnswers: Setting onMessage callback');
//             onMessageCallback = callback;
//         }
//     };
// };

// export const getExcelFile = async (param) => {
//     try {
//         const response = await apiClient.get(`/list_sql_files?session_id=${encodeURIComponent(param.thread_id)}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching users:', error);
//         throw error;
//     }
// };

// export const getPPTFile = async (param) => {
//     try {
//         const response = await apiClient.get(`/list_pptx_files?session_id=${encodeURIComponent(param.thread_id)}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching users:', error);
//         throw error;
//     }
// };

// export const generatePPT = async (params) => {
//     try {
//         const response = await apiClient.post('/generate_pptx', params);
//         return response.data;
//     } catch (error) {
//         console.error('Error while generating ppt:', error);
//         throw error;
//     }
// };

// export const getQuestionBankData = async (param) => {
//     try {
//         const response = await apiClient.get(`/question-bank-data`);
//         return response.data;
//     } catch (error) {
//         console.error('Error getting question bank data:', error);
//         throw error;
//     }
// };

// export const generatePPTForSelectedMsgs = async (params) => {
//     try {
//         const response = await apiClient.post('/generate_pptx_multi', params);
//         return response.data;
//     } catch (error) {
//         console.error('Error while generating ppt:', error);
//         throw error;
//     }
// };


import apiClient from './apiClient';

export const getAnswers = (params) => {
    let onMessageCallback = null;

    const promise = new Promise((resolve, reject) => {
        (async () => {
            try {

                // Note: apiClient already has the base URL with /api/
                const url = `${apiClient.defaults.baseURL}combineflow-invoke`;

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'text/event-stream',
                        // SSO removed: no auth headers
                    },
                    body: JSON.stringify(params),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let buffer = '';
                let finalMessage = null;

                const processStream = async () => {
                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) {
                            resolve(finalMessage);
                            return;
                        }

                        buffer += decoder.decode(value, { stream: true });
                        const lines = buffer.split('\n\n');
                        buffer = lines.pop() || '';

                        for (const line of lines) {
                            if (line.startsWith('data: ')) {
                                try {
                                    const data = JSON.parse(line.slice(6));
                                    if (data.type === 'stream_complete') {
                                        resolve(finalMessage);
                                        return;
                                    } else if (data.type === 'error') {
                                        reject(new Error(data.content));
                                        return;
                                    }
                                    
                                    if (onMessageCallback) {
                                        onMessageCallback(data);
                                    }
                                    if (data.type === 'ai') {
                                        finalMessage = data;
                                    }

                                } catch (e) {
                                    console.error('Error parsing event:', e, 'Line:', line);
                                }
                            }
                        }
                    }
                };
                await processStream();
            } catch (error) {
                console.error('getAnswers error:', error);
                reject(error);
            }
        })();
    });

    return {
        promise,
        onMessage: (callback) => {
            onMessageCallback = callback;
        }
    };
};

export const getExcelFile = async (param) => {
    try {
        const response = await apiClient.get(`list_sql_files?session_id=${encodeURIComponent(param.thread_id)}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching excel file list:', error);
        throw error;
    }
};

export const getPPTFile = async (param) => {
    try {
        const response = await apiClient.get(`list_pptx_files?session_id=${encodeURIComponent(param.thread_id)}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pptx file list:', error);
        throw error;
    }
};

export const generatePPT = async (params) => {
    try {
        const response = await apiClient.post('generate_pptx', params);
        return response.data;
    } catch (error) {
        console.error('Error while generating ppt:', error);
        throw error;
    }
};

export const getQuestionBankData = async () => {
    try {
        const response = await apiClient.get(`question-bank-data`);
        return response.data;
    } catch (error) {
        console.error('Error getting question bank data:', error);
        throw error;
    }
};

export const generatePPTForSelectedMsgs = async (params) => {
    try {
        const response = await apiClient.post('generate_pptx_multi', params);
        return response.data;
    } catch (error) {
        console.error('Error while generating ppt for multiple messages:', error);
        throw error;
    }
};

export const getHumanQuestion = async (thread_id) => {
    if (!thread_id) return { question: null };
    try {
        const response = await apiClient.get(`/human-input/${thread_id}`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status !== 404) {
           console.error('Error getting human question:', error);
        }
        return { question: null };
    }
};

export const submitHumanAnswer = async (thread_id, answer) => {
    if (!thread_id) return;
    try {
        const response = await apiClient.post(`/human-input/${thread_id}`, { answer });
        return response.data;
    } catch (error) {
        console.error('Error submitting human answer:', error);
        throw error;
    }
};
